<template>
    <home></home>
    <about></about>
    <speaking></speaking>
    <books></books>

</template>
